import * as React from "react";
import ReactTable, {TableProps} from "react-table";
import "react-table/react-table.css";
import "./draggableTable.scss";

interface IComponentProps {
	onReOrder: (target: number, dragged: number) => void;
	/**
	 * Text displayed when no rows were found.
	 */
	noDataText?: string;
}

type Props = IComponentProps & Partial<TableProps>

const DATA_TYPE = "dragged_table_header";

export default class DraggableTable extends React.Component<Props, {}> {

	public static defaultProps: Partial<Props> = {
		noDataText: "No results",
	};

	constructor(props: Props) {
		super(props);
		this.mountEvents = this.mountEvents.bind(this);
		this.renderNoDataComponent = this.renderNoDataComponent.bind(this);
	}

	mountEvents() {
		const headers = Array.prototype.slice.call(
			document.querySelectorAll(".draggable-header")
		);

		headers.forEach((header: HTMLSpanElement, i: number) => {
			header.setAttribute("draggable", "true");
			//the dragged header
			header.ondragstart = (e: DragEvent) => {
				e.dataTransfer.setData(DATA_TYPE, i.toString());
				e.stopPropagation();
			};

			header.ondrag = (e: DragEvent) => e.stopPropagation;

			header.ondragend = (e: DragEvent) => {
				e.stopPropagation();
			};

			//the dropped header
			header.ondragover = (e: DragEvent) => {
				e.dataTransfer.types.indexOf(DATA_TYPE) > -1 && e.preventDefault();
			};

			header.ondrop = (e: DragEvent) => {
				e.preventDefault();
				this.props.onReOrder(i, Number(e.dataTransfer.getData(DATA_TYPE)));
			};
		});
	}

	componentDidMount() {
		this.mountEvents();
	}

	componentDidUpdate() {
		this.mountEvents();
	}

	render() {
		return (
			<ReactTable {...this.props} NoDataComponent={this.renderNoDataComponent}/>
		);
	}

	renderNoDataComponent() {
		return (
			<div className="no-data_wrapper">
				<div className="no-data_text">{this.props.noDataText}</div>
			</div>
		)
	}
}
